interface MetricCardProps {
  label: string;
  value: string;
  trend?: { value: string; positive: boolean } | null;
}

export default function MetricCard({ label, value, trend }: MetricCardProps) {
  return (
    <div
      className="rounded p-4 transition-colors"
      style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--dash-card-hover)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--dash-card)'; }}
    >
      <div className="font-mono text-[10px] uppercase tracking-widest mb-1.5" style={{ color: 'var(--dash-text-muted)' }}>
        {label}
      </div>
      <div className="font-mono text-xl mb-1" style={{ color: 'var(--dash-text-primary)' }}>{value}</div>
      {trend && (
        <div className={`flex items-center gap-1 text-xs font-sans ${trend.positive ? 'text-emerald-400' : ''}`} style={!trend.positive ? { color: 'var(--dash-text-muted)' } : undefined}>
          <span className="text-[11px]">{trend.positive ? '\u2191' : '\u2193'}</span>
          {trend.value}
        </div>
      )}
    </div>
  );
}
